export const ADDITIONAL_CART_DETAILS_MAX_LENGTH = 200;

export const SUPPORTED_LANGUAGES: { code: string; name: string }[] = [
  { code: 'en', name: 'English' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'no', name: 'Norsk' },
  { code: 'es', name: 'Español' },
  { code: 'sv', name: 'Svenska' },
  { code: 'sr', name: 'Srpski' },
  { code: 'da', name: 'Dansk' },
];
